<template>
	<div class="login-wrapper" style="position: relative;">

		<section class="login-brand">
			<img src="@/assets/nssncompasslogo.png" class="logo" />
			<p v-if="loginDisabled" class="center">The industry's best real time, actionable DNO* data.</p>
			<p v-if="loginDisabled" class="center" style="font-size: 0.66em;">* Dead Nuts On</p>
			<p v-else class="center">The industry's best real time, actionable data.</p>
		</section>

		<section v-if="!showForgotPassword" class="login" ref="login_section">
			<h2 v-if="loginDisabled">Login temporarily disabled while we perform some database maintenance</h2>
			<h2 v-else>Please {{ forcePasswordChange ? 'enter a new password' : 'log in' }}...</h2>
			<label v-if="!forcePasswordChange">Username</label>
			<input v-if="!forcePasswordChange" type="text" v-model="userName" :disabled="loginDisabled" />
			<label>{{ forcePasswordChange ? 'New ' : '' }}Password</label>
			<div class="password-input">
				<input :type="showPassword ? 'text' : 'password'" v-model="password" :disabled="loginDisabled" @keyup.enter="doLogin()">
				<font-awesome-icon :icon="['fa-solid', showPassword ? 'fa-eye-slash' : 'fa-eye']" class="icon" @click="showPassword = !showPassword" />
			</div>
			<label v-if="forcePasswordChange">Type New Password Again</label>
			<div v-if="forcePasswordChange" class="password-input">
				<input :type="showPassword ? 'text' : 'password'" v-model="passwordConfirm" :disabled="loginDisabled" @keyup.enter="doLogin()">
				<font-awesome-icon :icon="['fa-solid', showPassword ? 'fa-eye-slash' : 'fa-eye']" class="icon" @click="showPassword = !showPassword" />
			</div>
			<div class="controls">
				<div :class="['button', loading || !userName || !password || loginDisabled ? 'disabled' : 'action']" @click="doLogin()">
					<span v-if="forcePasswordChange">Save New Password</span>
					<span v-else>Log In</span>
					<font-awesome-icon v-if="loading" icon="fa-solid fa-spinner" class="fa-spin icon" />
				</div>
			</div>
			<div class="message">{{ message }}</div>
			<div v-if="!loginDisabled && !forcePasswordChange" class="forgot" @click="showForgotPassword = true">
				Forgot your password?
			</div>
		</section>

		<section v-if="showForgotPassword" class="login">
			<h2>Request reset...</h2>
			<div class="message spaced">
				Enter your username and we will send an email with instructions for resetting your password.
			</div>
			<label>Username</label>
			<input type="text" v-model="userName" />
			<div class="controls">
				<div :class="['button', loading || !userName ? 'disabled' : 'action']" @click="doRequestReset()">
					<span>Request Reset</span>
					<font-awesome-icon v-if="loading" icon="fa-solid fa-spinner" class="fa-spin icon" />
				</div>
			</div>
			<div class="forgot" @click="showForgotPassword = false">
				Cancel password reset.
			</div>
		</section>

	</div>
</template>

<script>
export default {
	name: 'Login',
	data() {
		return {
			loading: false,
			message: '',
			userName: '',
			password: '',
			passwordConfirm: '',
			showPassword: false,
			showForgotPassword: false,
			loginDisabled: false,
			forcePasswordChange: false
		}
	},
	created() {
		// if (!this.getDevEnvironment) {
		//     this.loginDisabled = true
		// }
		this.updateSource('login')
		if (this.$route.query.logout) {
			this.doLogout()
		}
	},
	methods: {
		doLogin() {
			if (this.loading) { return }
			if (!this.userName || !this.password) { return }
			if (this.forcePasswordChange) {
				this.doPasswordUpdate()
				return
			}
			this.loading = true
			this.apiCall({ destination: 'login', data: { user_name: this.userName, password: this.password } }).then(obj => {
				this.loading = false
				this.message = obj.message
				if (obj.force_password_change) {
					this.forcePasswordChange = obj.user_id
					return
				}
				if (obj.status == 'success') {
					if (obj.user && obj.user.token) {
						sessionStorage.setItem('token', obj.user.token);
						sessionStorage.setItem('user', obj.user.user_name);
					}
					if (obj.user.user_type_code == 'SALES_REP') {
						this.$router.push('/dlink')
					} else {
						this.$router.push('/overview')
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		doPasswordUpdate() {
			if (this.password.length < 8) {
				this.message = 'Password must be at least 8 characters'
				return
			}
			if (this.password != this.passwordConfirm) {
				this.message = 'Passwords do not match'
				return
			}
			this.loading = true
			this.apiCall({ destination: 'reset_password', data: { user_id: this.forcePasswordChange, password: this.password } }).then(obj => {
				this.loading = false
				this.message = obj.message
				if (obj.status == 'success') {
					// time out for a moment to allow the user to see the success message
					setTimeout(() => {
						this.forcePasswordChange = false
						this.doLogin()
					}, 2000)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		doLogout() {
			this.apiCall({ destination: 'logout' })
			sessionStorage.removeItem('token')
			sessionStorage.removeItem('user')
			sessionStorage.removeItem('filters')
		},
		doRequestReset() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'forgot_password', data: { user_name: this.userName } }).then(obj => {
				this.loading = false
				this.message = obj.message
				this.showForgotPassword = false
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>
